import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ScreenService } from '@app/shared/services';
import { convertDateToMaskTimezone } from '@app/shared/utils';
import { Dialog } from 'primeng/dialog';
import { Observable, map } from 'rxjs';
import { finalize } from 'rxjs/operators';
import {
  ConfigService,
  EntityParams,
  EntityService,
  ErroMessages,
  IErroMessages,
  IErrorResponse,
  TokenService
} from 'viggo-sistemas-core-web';
import { IEntityPagination } from 'viggo-sistemas-core-web/modules/core/model/entity.model';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'dialog-info-grid',
  templateUrl: './dialog-info-grid.component.html',
  styleUrls: ['./dialog-info-grid.component.scss']
})
export class DialogInfoGridComponent extends EntityService<any>
  implements OnInit, AfterViewInit {
  @ViewChild('dialogInfoGrid') dialogInfoGrid: Dialog;
  KEY_PAGINATOR_DIALOG_MOV_PARTICIPANTE = 'PAGINATOR_SIZE_LS_MOV_PARCEIRO';
  data: any;
  valor_total: number;
  ultima_movimentacao: Date | string;
  titulo: string;
  entityService: any;
  id: string;
  urlEntity: string;
  subRota: string;
  entitiesName: string;
  filterEntity: string;
  url: string;
  generalEntity: any;
  columnDefs: any[];
  pageLength = 0;
  page_size = 0;
  page = 0;
  requisitions = 0;
  footerList = [];
  loading = true;
  noResults = false;
  errorMessage: string;
  filterEntities = [];
  KEY_DATA_NOT_SELECTION: any;
  KEY_DATA_SELECTION: any;
  KEY_DATA_ALL_SELECTED: any;
  errorResponse: IErrorResponse;
  orderBy: string | string[];

  public keywordAnoMes = new UntypedFormControl('', [Validators.required]);

  public keywordFormInputAno = new UntypedFormControl(null);
  public keywordFormInputMes = new UntypedFormControl(null);

  showMes = false;
  actualDate = true;
  today = new Date();

  constructor(
    public screenService: ScreenService,
    @Inject(MAT_DIALOG_DATA)
    data: {
      footerList: any[];
      page_size: number;
      order_by: string | string[];
      title: string;
      url: string;
      filterEntity: string;
      entitiesName: string;
      id: string;
      subRota: string;
      entityService: EntityService<any>;
      icon?: string;
      urlEntity: string;
      bodyMessage?: string;
      breakline?: boolean;
      titulo: string;
      columnDefs: any[];
      pageLength: number;
      page: number;
      entityName: string;
    },
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<DialogInfoGridComponent>,
    public router: Router,
    protected tokenService: TokenService,
    protected configService: ConfigService,
    protected currencyPipe: CurrencyPipe,
    protected datePipe: DatePipe,
    public matSnackBar: MatSnackBar
  ) {
    super({
      baseEntityEndPoint: 'parceiros',
      urlBackend: configService.backendURL
    });

    this.KEY_DATA_NOT_SELECTION = `DATA_NOT_SELECTION_${data.entityName.toUpperCase()}_DIALOG_GRID`;
    this.KEY_DATA_SELECTION = `DATA_SELECTION_${data.entityName.toUpperCase()}_DIALOG_GRID`;
    this.KEY_DATA_ALL_SELECTED = `SELECTED_ALL_TABLE_${data.entityName.toUpperCase()}_DIALOG_GRID`;

    this.titulo = data.title;
    this.id = data.id;
    this.subRota = data.subRota;
    this.entityService = data.entityService;
    this.data = data;
    this.filterEntity = data.filterEntity;
    this.url = data.url;
    this.page_size = data.page_size ? data.page_size : this.page_size;
    this.page = data.page;
    this.footerList = data.footerList;
    this.entitiesName = data.entitiesName;
    this.columnDefs = data.columnDefs;
    this.pageLength = data.pageLength ? data.pageLength : this.pageLength;
    this.orderBy = data.order_by ? data.order_by : this.orderBy;
  }

  ngAfterViewInit() {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.dialogInfoGrid.maximize();
  }

  ngOnInit() {
    this.keywordFormInputMes.setValue(new Date());
    this.confirmarSelecaoAnoMes(true);
  }

  override getEntitiesByParams(
    params: string | EntityParams<any>,
    domainId?: string,
    require_pagination = false
  ): Observable<any> {
    let paramsAux: string = null;
    let paramsHttp = new HttpParams();

    if (typeof params === 'string') {
      paramsAux = `?${params}${
        require_pagination ? '&require_pagination=true' : ''
      }`;
      // if (domainId) paramsAux += `&timezone=${moment().format('ZZ')}`;
      if (this.orderBy) paramsAux += `&order_by=${this.orderBy}`;
    }
    // TODO implementar entidade pra padronizar com compenentes genericos
    else {
      if (params.where) paramsHttp = this.getParams(params.where);
      if (domainId) paramsHttp = paramsHttp.set('domain_id', domainId);
      if (require_pagination) {
        paramsHttp = paramsHttp.set('require_pagination', require_pagination);
      }
      if (params.pagination) {
        paramsHttp = paramsHttp.set('page', params.pagination.page);
        paramsHttp = paramsHttp.set('page_size', params.pagination.page_size);
        if (params.pagination.require_pagination)
          paramsHttp = paramsHttp.set(
            'require_pagination',
            params.pagination.require_pagination
          );
      }
      if (params.include && params.include.length)
        paramsHttp = paramsHttp.set('include', params.include.join(','));
      if (params.order_by && params.order_by.length)
        paramsHttp = paramsHttp.set('order_by', params.order_by.join(','));
      if (params.list_options)
        paramsHttp = paramsHttp.set('list_options', params.list_options);
      paramsAux = null;
    }

    let response = this.http
      .get<any>(this.configService.backendURL + this.url + paramsAux, {
        headers: this.getHeader(),
        params: paramsHttp
      })
      .pipe(
        map(data => {
          if (
            (typeof params === 'object' &&
              params.pagination &&
              params.pagination.require_pagination) ||
            require_pagination
          ) {
            data = data as IEntityPagination<any>;
            return {
              data: data[this.entitiesName],
              pagination: data.pagination
            };
          }
          data = data as any[];
          return data[this.entitiesName];
        })
      );

    return response;
  }

  onLoad(page = 0, reload?: boolean, notFirstReq?: boolean) {
    if (notFirstReq) this.requisitions = 0;
    this.requisitions += 1;
    if (this.requisitions === 1) {
      //this.entities = [];
      this.filterEntities = [];
      this.loading = true;
      this.page = reload ? this.page : page;

      var params = `page=${this.page}&page_size=${
        this.page_size
      }&list_options=ACTIVE_ONLY&domain_id=${this.tokenService.getDomain().id}`;

      const { firstDay, lastDayDate } = this.getInputValueSelectedMes();
      if (firstDay && lastDayDate) {
        params += `&de_filter=${convertDateToMaskTimezone(
          firstDay
        )}&ate_filter=${convertDateToMaskTimezone(
          lastDayDate
        )}&attributes_filter=data_hora`;
      }

      const req = this.getEntitiesByParams(
        params,
        this.tokenService.getDomain().id,
        true
      );
      req
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe(
          entities => {
            this.filterEntities = entities.data;
            if (this.filterEntity)
              this.filterEntities = entities.data[this.filterEntity];
            this.filterEntities = this.filterEntities.map(entity => {
              entity.active = true;
              return entity;
            });
            this.generalEntity = entities.data;
            this.page = entities.data.pagination.page;
            this.pageLength = entities.data.pagination.total;
            this.valor_total = entities.data.valor_total;
            this.ultima_movimentacao = entities.data.ultima_movimentacao;
          },
          (err: HttpErrorResponse) => {
            this.errorResponse = {
              title: 'Erro detectado',
              message: err.message,
              status: err.status.toString(),
              statusError: err.statusText
            } as IErrorResponse;
            this.displayError(err, true);
          },
          () => {
            this.loading = false;
            // this.updateDataSelection();
            this.filterEntities.length === 0
              ? (this.noResults = true)
              : (this.noResults = false);
          }
        );
    }
  }

  getFooterInfo() {
    let mock = this.footerList.map(item => {
      if (item.pipe === 'currency') {
        if (item.field.split('.').length > 1) {
          let final_field = this.generalEntity[`${item.field.split('.')[0]}`];
          for (let subField of item.field.split('.')) {
            final_field = final_field[subField];
          }

          return {
            title: item.title,
            subTitle: this.currencyPipe.transform(final_field, 'BRL'),
            colorSubtitle: 'black'
          };
        }
        return {
          title: item.title,
          subTitle: this.currencyPipe.transform(this.valor_total, 'BRL'),
          colorSubtitle: 'black'
        };
      } else if (item.pipe === 'date') {
        if (item.field.split('.').length > 1) {
          let final_field = this.generalEntity[`${item.field.split('.')[0]}`];
          for (let subField of item.field.split('.')) {
            final_field = final_field[subField];
          }

          return {
            title: item.title,
            subTitle: this.datePipe.transform(final_field, 'shortDate'),
            colorSubtitle: 'black'
          };
        }
        return {
          title: item.title,
          subTitle: this.datePipe.transform(
            this.ultima_movimentacao ?? new Date(),
            'shortDate'
          ),
          colorSubtitle: 'black'
        };
      }

      return {
        title: item.title,
        subTitle: this.generalEntity[item.field],
        colorSubtitle: 'black'
      };
    });

    return mock;
  }

  handlePage(event) {
    this.page_size = event.rows;
    this.onLoad(event.page, false, true);
  }

  confirmarSelecaoAnoMes(actualDate = false) {
    this.actualDate = actualDate;
    const { firstDay, lastDayDate } = this.getInputValueSelectedMes();

    this.keywordAnoMes.setValue(
      `${firstDay.toLocaleDateString()} - ${lastDayDate.toLocaleDateString()}`
    );
    this.onLoad(0, false, true);
  }

  getInputValueSelectedMes() {
    const rangeDate = this.keywordFormInputMes.value as Date;
    const dateFirst = rangeDate as Date;
    var dateLast = rangeDate as Date;

    const firstDay = new Date(dateFirst.getFullYear(), dateFirst.getMonth(), 1);
    var lastDay = new Date(
      dateLast.getFullYear(),
      dateLast.getMonth() + 1,
      0
    ).getDate();

    var lastDayDate = new Date(
      dateLast.getFullYear(),
      dateLast.getMonth(),
      this.actualDate
        ? dateLast.getDate()
        : dateLast.getMonth() === new Date().getMonth()
        ? new Date().getDate()
        : lastDay
    );

    return { firstDay, lastDayDate };
  }

  selecionarIrPraProx() {
    this.showMes = true;
    this.keywordFormInputMes.setValue([this.keywordFormInputAno.value]);
  }

  removerSelecaoMes() {
    this.showMes = false;
    this.keywordFormInputMes.setValue(null);
  }

  removerSelecaoAnoMes() {
    this.showMes = false;
    this.keywordFormInputAno.setValue(null);
    this.keywordFormInputMes.setValue(null);
  }

  public clearFilter() {
    this.noResults = false;
    this.keywordAnoMes.setValue('');
    this.onLoad(0, false, true);
  }

  enterSearch(event) {
    if (event.key === 'Enter') {
      this.onLoad(0, false, true);
    }
  }

  gerarRelatorio() {
    const { firstDay, lastDayDate } = this.getInputValueSelectedMes();
    const where = {
      de_filter: convertDateToMaskTimezone(firstDay),
      ate_filter: convertDateToMaskTimezone(lastDayDate),
      attributes_filter: 'data_hora',
      domain_id: this.tokenService.getDomain().id
    };
    this.dialogRef.close({ confirm: true, where });
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.matDialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.showMessageObject(txtMsg);
    // errorMsg.checkError();
  }

  getMessageError() {
    if (!this.errorResponse) return '';
    return `Identificamos o erro ${this.errorResponse.status} - ${this.errorResponse.statusError} no processamento dos dados!`;
  }

  getFirstConfigPagination() {
    return this.page * this.page_size;
  }
}
